import React from "react"
import styled from "styled-components"


const Button = styled.button`
    background-color: Transparent;
    background-repeat:no-repeat;
    border: none;
    overflow: hidden;
    outline:none;
    padding: 0em;
    text-align: center;
    content-align: center;
    align-self: center;
    justify-content: center;
    margin: 0, auto;
	cursor: pointer;
`;

const Img = styled.img`
    height: 3vmax;
    pointer-events: auto;
    src: $(props => props.src);
    display: flex;
	justify-content: center;
	align-self: center;
	margin: 0, auto;
`;


const Logo = ({theme,  toggleTheme }) => {
    return (
      <Button onClick={toggleTheme}><Img src={theme.logo} /></Button>
    );
};

export default Logo;